import { useMutation } from "urql";

import { ApproveWaiveDocument } from "../../../graphql/generated.ts";

export function useApproveWaive() {
  return useMutation(ApproveWaiveDocument);
}
